function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { cva } from "class-variance-authority";
import { forwardRef } from "react";
import { cn } from "../../common/helpers.js";
const classes = cva([
    'animate-pulse',
    'bg-gray-100',
    'block'
], {
    variants: {
        variant: {
            // Origin and scale effects make skeleton the size of text within the given line height
            text: [
                'rounded',
                'h-auto',
                String.raw`before:empty:content-['\00a0']`,
                'origin-[0px_55%]',
                'scale-y-[0.6]',
                'my-0'
            ],
            rounded: [
                'rounded'
            ],
            circular: [
                'rounded-full'
            ],
            rectangular: []
        },
        hasChildren: {
            true: [
                '[&>*]:hidden'
            ],
            false: []
        },
        hasHeight: {
            true: [],
            false: []
        },
        hasWidth: {
            true: [],
            false: []
        }
    },
    compoundVariants: [
        {
            hasChildren: true,
            hasHeight: false,
            className: [
                'h-auto'
            ]
        },
        {
            hasChildren: true,
            hasWidth: false,
            className: [
                'max-w-fit'
            ]
        }
    ]
});
/**
 * Skeleton - [API](https://scl.sharp.com/?path=/docs/base-skeleton)
 */ const Skeleton = /*#__PURE__*/ forwardRef((_param, ref)=>{
    var { variant = 'text', height, width, className, role = 'status', style = {} } = _param, props = _object_without_properties(_param, [
        "variant",
        "height",
        "width",
        "className",
        "role",
        "style"
    ]);
    const hasChildren = !!props.children;
    const hasWidth = !!width;
    const hasHeight = !!height;
    return /*#__PURE__*/ _jsx("span", _object_spread_props(_object_spread({}, props), {
        ref: ref,
        role: role,
        className: cn(classes({
            variant,
            className,
            hasChildren,
            hasHeight,
            hasWidth
        }), className),
        style: _object_spread({
            height,
            width
        }, style)
    }));
});
export { Skeleton };
